import React from 'react';
import ReactECharts from 'echarts-for-react';
import { Box, Skeleton, Typography } from '@mui/material';

type BarChartProps = {
  name: string;
  data: number[];
  onClick?: () => void;
  expand?: boolean;
  loading?: boolean;
};

export const BarChart: React.FC<BarChartProps> = ({
  name,
  data,
  onClick,
  expand,
  loading,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };

  const option = {
    backgroundColor: 'transparent',
    grid: {
      left: 8,
      right: 12,
      top: expand ? 40 : 16,
      bottom: 8,
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: ['0-1', '1-2', '2-5', '5-10', '10-15', '15-20', '20+'],
      axisLabel: {
        fontSize: expand ? 14 : 10,
        rotate: 0,
        interval: 0,
      },
    },
    yAxis: {
      type: 'value',
      axisLabel: {
        fontSize: expand ? 14 : 10,
        rotate: 0,
        interval: 0,
      },
    },
    series: [
      {
        data: data,
        type: 'bar',
        itemStyle: {
          color: '#059669',
          borderRadius: [4, 4, 0, 0],
        },
      },
    ],
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: onClick ? 'pointer' : 'default',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      {loading ? (
        <Skeleton
          variant="rounded"
          height={160}
          width="100%"
          sx={{ borderRadius: 2 }}
        />
      ) : (
        <ReactECharts
          option={option}
          style={{ height: expand ? '220px' : '170px', width: '100%' }}
          opts={{ renderer: 'svg' }}
        />
      )}
      {!loading && (
        <Typography
          variant="caption"
          fontWeight={700}
          color="primary.main"
          textAlign="center"
          sx={{
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            mt: 0.5,
          }}
        >
          {name}
        </Typography>
      )}
    </Box>
  );
};

export default BarChart;
